import React from 'react';
import { withTheme } from 'styled-components';

import { translate } from '~/utils';

const Tooltip = ({ data, xScale, yScale, ySelector, theme, radius = 3.5 }) => {
  if (!data) {
    return null;
  }

  const xValue = data[config.columns.PERCENTAGE];
  const x = xScale(xValue);
  const yValue = data[ySelector];
  const y = yScale(yValue);

  return (
    <g transform={translate(x, y)} className="tooltip">
      <circle fill={theme.colors.highlight} cx={0} cy={0} r={radius} />
    </g>
  );
};

export default withTheme(Tooltip);
